import { EventBlocks, EventBlocksType, EventUniqueBlocks } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";

export const getEventBlockType = (type: EventBlocksType) => {
  switch (type) {
    case EventUniqueBlocks.venue:
      return {
        dataKey: IDataKeys.eventVenueBlock,
        api: {
          list: API_ENDPOINTS.EVENT_VENUE_BLOCKS,
          item: API_ENDPOINTS.EVENT_VENUE_BLOCK,
        },
      };
    case EventUniqueBlocks.people:
      return {
        dataKey: IDataKeys.eventPeopleBlock,
        api: {
          list: API_ENDPOINTS.EVENT_PEOPLE_BLOCKS,
          item: API_ENDPOINTS.EVENT_PEOPLE_BLOCK,
        },
      };
    case EventBlocks.schedule:
      return {
        dataKey: IDataKeys.eventScheduleBlock,
        api: {
          list: API_ENDPOINTS.EVENT_SCHEDULE_BLOCKS,
          item: API_ENDPOINTS.EVENT_SCHEDULE_BLOCK,
        },
      };
    case EventBlocks.infoBlock:
      return {
        dataKey: IDataKeys.eventInfoBlock,
        api: {
          list: API_ENDPOINTS.EVENT_INFO_BLOCKS,
          item: API_ENDPOINTS.EVENT_INFO_BLOCK,
        },
      };
    case EventBlocks.guestlist:
      return {
        dataKey: IDataKeys.eventGuestListBlock,
        api: {
          list: API_ENDPOINTS.EVENT_GUESTLIST_BLOCKS,
          item: API_ENDPOINTS.EVENT_GUESTLIST_BLOCK,
        },
      };
    case EventBlocks.travel:
      return {
        dataKey: IDataKeys.eventTravelBlock,
        api: {
          list: API_ENDPOINTS.EVENT_TRAVEL_BLOCKS,
          item: API_ENDPOINTS.EVENT_TRAVEL_BLOCK,
        },
      };
    case EventBlocks.accommodation:
      return {
        dataKey: IDataKeys.eventAccommodationBlock,
        api: {
          list: API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCKS,
          item: API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK,
        },
      };
    default:
      return null;
  }
};
